import { render, staticRenderFns } from "./ArticleHotContainer.vue?vue&type=template&id=704641c6&"
import script from "./ArticleHotContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleHotContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports